import React from 'react';
import classnames from 'classnames';
import GlobalProps from '../globalProps';

import './Spinner.css';

export interface Props extends GlobalProps {
  scale?: string;
  color?: string;
  text?: string;
}

export function Spinner({ scale, color = 'var(--color-tint)', text, style, className }: Props): JSX.Element {
  return (
    <div className={classnames('spinner__container', className)} style={style}>
      <div className="spinner" style={{ transform: `scale(${scale})` }}>
        <div className="spinner__rotation">
          <svg height="26px" width="26px">
            <circle
              className="spinner__circle"
              cx="12"
              cy="12"
              r="10"
              stroke={color}
              strokeWidth="3"
              fill="transparent"
            />
          </svg>
        </div>
      </div>
      {text && <span className="spinner__text">{text}</span>}
    </div>
  );
}
